export const AlarmCauseType = {
  Planned: 0,
  Unplanned: 1,
  BusinessSourced: 2,
};
